import { OktaAuthManager } from '../okta-auth-manager';
import { createContext, Provider, useContext } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaClientConfiguration } from '@ssar-app/okta-authn-core';

export type OktaAuthnAppState = {
  oktaClientConfigurations: OktaClientConfiguration[];
  oktaClientCode?: string;
  loginMountPath: string;
  oktaAuthManager: OktaAuthManager;
  setCurrentOktaClientCode(oktaClientCode: string): void;
};

const OktaAuthnAppContext = createContext<OktaAuthnAppState | undefined>(
  undefined,
);

const OktaAuthnAppProvider =
  OktaAuthnAppContext.Provider as Provider<OktaAuthnAppState>;

export const useOktaAuthnAppContext = (): OktaAuthnAppState => {
  const context = useContext(OktaAuthnAppContext);
  if (!context) {
    throw new Error('OktaAutnAppContext not found in the hierarchy');
  }
  return context;
};

export { OktaAuthnAppProvider as OktaAuthnAppContext };

export const useOktaAuthnOktaAuth = (): OktaAuth | undefined => {
  const { oktaClientCode } = useOktaAuthnAppContext();
  const oktaAuthManager = useOktaAuthManager();
  if (oktaClientCode) {
    const toReturn = oktaAuthManager.getForOktaClientCode(oktaClientCode);
    return toReturn;
  }
  return undefined;
};

export const useOktaAuthManager = (): OktaAuthManager => {
  const { oktaAuthManager } = useOktaAuthnAppContext();
  return oktaAuthManager;
};

export type PathContextState = {
  basePath: string;
  buildPath: (...paths: string[]) => string;
};
const PathContext = createContext<PathContextState | undefined>(undefined);

const PathContextProvider = PathContext.Provider;

export const usePathContext = (): PathContextState => {
  const context = useContext(PathContext);
  if (!context) {
    throw new Error('PathContext was not found in the hierarchy');
  }
  return context;
};

export { PathContextProvider as PathContext };
